import React, { useEffect } from 'react'
import CustomNextSeo from 'components/CustomNextSeo'
import { useSearchParams } from 'next/navigation'
import { useVerify3DSPayment } from '../../hooks/useVerify3DSPayment'
import { useRouter } from 'next/router'
import { notificationController } from '../../notificationController/notificationController'
import { RouteEnum } from '../../enums/RouteEnum'

const PaymentCallback: React.FC = () => {
  const searchParams = useSearchParams()
  const router = useRouter()

  const { refetch } = useVerify3DSPayment({
    paymentIntent: searchParams.get('payment_intent'),
  })

  useEffect(() => {
    if (searchParams.get('payment_intent')) {
      refetch().then((res) => {
        if (res.isSuccess && res.data?.success) {
        } else {
          const errorMsg = (res.error as any)?.response?.data?.error

          notificationController.show({
            description:
              typeof errorMsg === 'string'
                ? errorMsg
                : 'Payment failed, please try again!',
            status: 'error',
          })
        }
      })
      router.push(RouteEnum.DASHBOARD_CUSTOMER_PORTAL)
    }
  }, [refetch, router, searchParams])

  return (
    <>
      <CustomNextSeo />
    </>
  )
}

export default PaymentCallback
